import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";
import reportUtils from "../../../../../../utils/report-utils.js";

const reportId = "users-labels-with-more-passage";
const reportName = "Marcações de passagens por agentes";
const UsersLabelsWithMorePassage = ({data}) => {
  useEffect(() => {
    const allLabels = [];
    const allValues = [];

    for (const item of data) {
      allLabels.push(reportUtils.formatText(item.name));
      allValues.push(item.total);
    }

    const chartLabels = allLabels.slice(0, 15);
    const chartValues = allValues.slice(0, 15);

    GraphicUtils.barChart(reportId, chartValues, chartLabels, false);
    data && data.length > 0 && ReportUtils.createExportableTable(allLabels, allValues, "Marcações por agentes");
  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName} {data?.length >= 15 ? ' (TOP 15)' : ''}</span>
        <div className="mt-3" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default UsersLabelsWithMorePassage;